/* =============================================
   DOCTOR MADE — Global JS
   File: assets/global.js

   Features:
   - IntersectionObserver でスクロール fadeIn
   - ナビゲーション スクロール時クラス付与
   ============================================= */

(function () {
  'use strict';

  /* ---- Scroll Fade-in ---- */
  const initScrollFadeIn = () => {
    const targets = document.querySelectorAll('.fade-in');
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    targets.forEach((el) => observer.observe(el));
  };

  /* ---- Header scroll class ---- */
  const initHeaderScroll = () => {
    const header = document.querySelector('.site-header, header.header');
    if (!header) return;

    const onScroll = () => {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  };

  /* ---- Init ---- */
  const init = () => {
    initScrollFadeIn();
    initHeaderScroll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
